/* /assets/ctr-bryce-recipes.js */

(function () {
  function initSection(section) {
    var tabs = section.querySelectorAll('.ctr-bryce-recipes__tab');
    var panels = section.querySelectorAll('.ctr-bryce-recipes__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = parseInt(tab.dataset.tabIndex, 10);

        tabs.forEach(function (t) {
          t.classList.remove('ctr-bryce-recipes__tab--active');
        });
        tab.classList.add('ctr-bryce-recipes__tab--active');

        panels.forEach(function (p) {
          p.classList.remove('ctr-bryce-recipes__panel--active');
        });
        if (panels[index]) {
          panels[index].classList.add('ctr-bryce-recipes__panel--active');
        }
      });
    });
  }

  function setup() {
    document.querySelectorAll('[data-section-type="ctr-bryce-recipes"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-section-type="ctr-bryce-recipes"]');
      if (section) initSection(section);
    });
  }
})();
